var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './ImageVideoModal.scss';
import closeButton from '../../assets/images/videoModal/close.png';
import parse from 'html-react-parser';
var Modal = function (data) {
    var wistiaId;
    data.url.includes('wistia')
        ? (wistiaId = data.url.split('/')[data.url.split('/').length - 1])
        : '';
    return (_jsx("div", __assign({ className: "relative md:flex md:items-center md:justify-center video-modal-container" }, { children: _jsx("div", __assign({ className: "fixed video-modal-backdrop" }, { children: _jsxs("div", __assign({ className: "video-modal-video-player-container md:flex items-center" }, { children: [_jsx("div", __assign({ className: "video-modal-close-button" }, { children: _jsx("img", { src: closeButton, onClick: data.closeModal }, void 0) }), void 0),
                    _jsx("div", __assign({ className: "video-modal-video-player" }, { children: data.url.includes('vimeo') ? (data.html && parse(data.html)) : (_jsx("iframe", { src: "//fast.wistia.net/embed/iframe/" + wistiaId, scrolling: "no", name: "wistia_embed", allowFullScreen: true }, void 0)) }), void 0)] }), void 0) }), void 0) }), void 0));
};
export default Modal;
